import Nullstack from 'nullstack';
export default function IconBrandSnowflake({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-snowflake",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14 21v-5.5l4.5 2.5"
  }), "   ", Nullstack.element("path", {
    d: "M10 21v-5.5l-4.5 2.5"
  }), "   ", Nullstack.element("path", {
    d: "M3.5 14.5l4.5 -2.5l-4.5 -2.5"
  }), "   ", Nullstack.element("path", {
    d: "M20.5 9.5l-4.5 2.5l4.5 2.5"
  }), "   ", Nullstack.element("path", {
    d: "M10 3v5.5l-4.5 -2.5"
  }), "   ", Nullstack.element("path", {
    d: "M14 3v5.5l4.5 -2.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 11l1 1l-1 1l-1 -1z"
  }), " ");
}